var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSenchatouch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7CBA3D;}\r\n\t.st1{fill:#C5D83E;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9,29.9L40.9,29.9c-0.9-4.6-3.7-8.5-7.5-10.8c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-0.4-0.2-0.7-0.4-1.1-0.6L22,13.2l0,0l0,0l0,0L21.5,13c0,0-0.1,0-0.1,0h0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-1.1-0.5-2-1.4-2.6-2.4c-0.8-1.1-1.2-2.5-1.2-3.9c0-2.7,1.5-5.1,3.8-6.2l-3.3,1.7c-5.5,2.7-9.2,8.4-9.2,14.9L9,19.8h0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0.9,5.2,4.2,9.5,8.6,11.9l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l1,0.5 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l1.2,0.6l8.6,4.3c2.4,1.1,4,3.6,4,6.4v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0 c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,1.8-0.7,3.5-1.9,4.7c-0.5,0.6-1.2,1-1.8,1.4l2.1-1.1L32,48c5.5-2.7,9.2-8.4,9.2-14.9 L40.9,29.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,16.9c0-6.5,3.7-12.1,9.2-14.9l3.3-1.7c-2.2,1.2-3.8,3.5-3.8,6.2c0,1.5,0.4,2.8,1.2,3.9 c-1.1,2.8-1.8,5.7-2,8.6c-1.4,0.7-3,1.1-4.7,1.1c-0.2,0-0.3,0-0.5,0c-0.9,0-1.7-0.2-2.5-0.4L8.7,16.9L8.7,16.9z M32.5,43.5 L32.5,43.5L32.5,43.5L32.5,43.5z M32.5,43.5L32.5,43.5L32.5,43.5L32.5,43.5z M32.5,43.5C32.5,43.5,32.5,43.5,32.5,43.5 C32.5,43.5,32.5,43.5,32.5,43.5L32.5,43.5z M32.5,43.5L32.5,43.5L32.5,43.5L32.5,43.5z M32.5,43.5L32.5,43.5L32.5,43.5L32.5,43.5z  M32.5,43.5L32.5,43.5L32.5,43.5L32.5,43.5z M32.5,43.5C32.5,43.5,32.5,43.5,32.5,43.5C32.5,43.5,32.5,43.5,32.5,43.5L32.5,43.5z  M32.5,43.5L32.5,43.5L32.5,43.5L32.5,43.5z M32.5,43.5C32.5,43.5,32.5,43.5,32.5,43.5C32.5,43.5,32.5,43.5,32.5,43.5L32.5,43.5z  M32.5,43.6L32.5,43.6L32.5,43.6L32.5,43.6z M32.5,43.6C32.5,43.6,32.5,43.6,32.5,43.6C32.5,43.6,32.5,43.6,32.5,43.6L32.5,43.6z  M32.5,43.6L32.5,43.6L32.5,43.6L32.5,43.6z M32.5,43.6L32.5,43.6L32.5,43.6L32.5,43.6z M32.5,43.6L32.5,43.6L32.5,43.6L32.5,43.6z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -220.9109,
    y1: 275.0221,
    x2: -220.9334,
    y2: 274.9515,
    gradientTransform: "matrix(76.5487 0 0 -102.8184 16924.8496 28300.9453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AACE36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2FA042"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.7,32.2l-1-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0 C13.1,29.3,9.8,25,9,19.8c0.8,0.2,1.6,0.4,2.5,0.4c0.2,0,0.3,0,0.5,0c1.7,0,3.3-0.4,4.7-1.1C16.3,23.6,17.1,28.1,18.7,32.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.0794,
    y1: 275.439,
    x2: -222.952,
    y2: 275.4198,
    gradientTransform: "matrix(192.9304 0 0 -307.456 43054.9023 84713.6797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79A933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#70A333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#559332"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#277B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#005F27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005020"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22,13.2L21.5,13c0,0-0.1,0-0.1,0h0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-1.1-0.5-2-1.4-2.6-2.4c-1.1,2.8-1.8,5.7-2,8.6c1.9-1,3.5-2.5,4.5-4.4L22,13.2L22,13.2z M40.9,29.9C37,32.5,32.3,34,27.3,34 c-0.4,0-0.8,0-1.1,0c-2.2-0.1-4.3-0.5-6.3-1.1l8.6,4.3c2.4,1.1,4,3.6,4,6.4v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0 c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,1.8-0.7,3.5-1.9,4.7c-0.5,0.6-1.2,1-1.8,1.4l2.1-1.1L32,48c5.5-2.7,9.2-8.4,9.2-14.9 L40.9,29.9L40.9,29.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.0475,
    y1: 275.1617,
    x2: -222.9829,
    y2: 275.0343,
    gradientTransform: "matrix(191.0404 0 0 -162.56 42630.8867 44743.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79AB35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#7CBA3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AA4B"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.3,34c-0.4,0-0.8,0-1.1,0c-2.2-0.1-4.3-0.5-6.3-1.1l-1.2-0.6c-1.7-4.1-2.4-8.6-2-13.1 c1.9-1,3.5-2.5,4.5-4.4l0.8-1.5l10.3,5.1c0.4,0.2,0.7,0.4,1.1,0.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c3.8,2.4,6.6,6.3,7.5,10.8C37,32.5,32.3,34,27.3,34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenchatouch);
export default __webpack_public_path__ + "static/media/senchatouch.aaf576d015cf64b088a763d9e51d2a17.svg";
export { ForwardRef as ReactComponent };